import { parseConfig } from "browserslist";
import ParseDBF from "../../lib/ParseDBF";

const { readString } = require("react-papaparse");

const Types = {
	COURSES_WEBINAR_ATTENDANCE_FILE_NAME: "COURSES_WEBINAR_ATTENDANCE_FILE_NAME",
	COURSES_WEBINAR_ATTENDANCE_DATA_LOADED: "COURSES_WEBINAR_ATTENDANCE_DATA_LOADED",
	COURSES_CHANGE_WEBINAR_ATTENDEE_NAME: "COURSE_CHANGE_WEBINAR_ATTENDEE_NAME",
	COURSES_CHANGE_WEBINAR_ATTENDEE_EMAIL: "COURSE_CHANGE_WEBINAR_ATTENDEE_EMAIL",
	COURSES_SET_WEBINAR_ATTENDEE_CERTIFICATE_STATUS: "COURSE_SET_WEBINAR_ATTENDEE_CERTIFICATE_STATUS",
	COURSES_ADD_NEW_ATTENDEE: "COURSES_ADD_NEW_ATTENDEE",
	COURSES_SET_ALL_CERTIFICATES_STATUS: "COURSES_SET_ALL_CERTIFICATES_STATUS",
};

const toBuffer = (ab) => {
	var buf = Buffer.alloc(ab.byteLength);
	var view = new Uint8Array(ab);
	for (var i = 0; i < buf.length; ++i) {
		buf[i] = view[i];
	}
	return buf;
};

const webinarAttendanceImportSetFileName = (fileName) => ({
	type: Types.COURSES_WEBINAR_ATTENDANCE_FILE_NAME,
	fileName,
});

const webinarAttendanceDataLoaded = ({ fields, data }) => ({
	type: Types.COURSES_WEBINAR_ATTENDANCE_DATA_LOADED,
	fields,
	data,
});

const handleWebinarAttendanceFiles = (files) => {
	return (dispatch, getState) => {
		if (files != null) {
			let reader = new FileReader();
			let file = files[0];
			console.log("file", file);

			dispatch(webinarAttendanceImportSetFileName(file.name));

			const fileParts = file.name.toLowerCase().split(".");
			const fileExtension = fileParts[fileParts.length - 1];

			reader.onload = () => {
				let attendanceData = null;

				switch (fileExtension) {
					case "csv":
						{
							const parsedCSV = readString(reader.result, { header: false, skipEmptyLines: true });
							const headerIndex = parsedCSV.data.findIndex((name) => name[0] === "Attendee Details");
							//Removes everything up until Attendee Details
							parsedCSV.data.splice(0, headerIndex + 1);

							//Loop through parsedCSV data and convert them into objects
							for (const i in parsedCSV.data) {
								if (i == 0) continue;

								let details = {};

								/* Converts to from Array to Object, example:
									0: "john" -> name: "john" */
								for (const value in parsedCSV.data[0]) {
									details[parsedCSV.data[0][value]] = parsedCSV.data[i][value];
								}

								let firstName = details["First Name"].toLowerCase();
								let lastName = details["Last Name"].toLowerCase();

								//Check if there is a space in the first name and capitalize the first letter of every word
								if (details["First Name"].includes(" ")) {
									const splitFirstName = firstName.split(" ");
									firstName = "";

									for (const i in splitFirstName) {
										if (i != 0) firstName += " ";
										firstName +=
											splitFirstName[i].charAt(0).toUpperCase() + splitFirstName[i].slice(1);
									}
								} else {
									firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
								}

								//Check if there is a space in the last name and capitalize the first letter of every word
								if (details["Last Name"].includes(" ")) {
									const splitLastName = lastName.split(" ");
									lastName = "";

									for (const i in splitLastName) {
										if (i != 0) lastName += " ";
										lastName +=
											splitLastName[i].charAt(0).toUpperCase() + splitLastName[i].slice(1);
									}
								} else {
									lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
								}

								details["First Name"] = firstName;
								details["Last Name"] = lastName;

								parsedCSV.data[i] = details;
							}

							parsedCSV.data.splice(0, 1);

							dispatch(
								webinarAttendanceDataLoaded({
									fields: parsedCSV.meta.fields,
									data: parsedCSV.data,
								}),
							);
						}
						break;

					case "dbf":
					default:
						{
							var buffer = toBuffer(reader.result);
							const headerIndex = buffer.data.findIndex((name) => name[0] === "Attendee Details");
							//Removes everything up until Attendee Details
							buffer.data.splice(0, headerIndex + 1);

							//Loop through buffer data and convert them into objects
							for (const i in buffer.data) {
								if (i == 0) continue;

								let details = {};

								/* Replaces numbers into keys, example:
									0: "john" -> name: "john" */
								for (const value in buffer.data[0]) {
									details[buffer.data[0][value]] = buffer.data[i][value];
								}

								let firstName = details["First Name"].toLowerCase();
								let lastName = details["Last Name"].toLowerCase();

								//Check if there is a space in the first name and capitalize the first letter of every word
								if (details["First Name"].includes(" ")) {
									const splitFirstName = firstName.split(" ");
									firstName = "";

									for (const i in splitFirstName) {
										if (i != 0) firstName += " ";
										firstName +=
											splitFirstName[i].charAt(0).toUpperCase() + splitFirstName[i].slice(1);
									}
								} else {
									firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
								}

								//Check if there is a space in the last name and capitalize the first letter of every word
								if (details["Last Name"].includes(" ")) {
									const splitLastName = lastName.split(" ");
									lastName = "";

									for (const i in splitLastName) {
										if (i != 0) lastName += " ";
										lastName +=
											splitLastName[i].charAt(0).toUpperCase() + splitLastName[i].slice(1);
									}
								} else {
									lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
								}

								details["First Name"] = firstName;
								details["Last Name"] = lastName;

								buffer.data[i] = details;
							}

							buffer.data.splice(0, 1);

							ParseDBF(buffer).then((data) => {
								dispatch(
									webinarAttendanceDataLoaded({
										fields: data.fields,
										data: data.records,
									}),
								);
							});
						}
						break;
				}
			};

			if (fileExtension == "csv") {
				reader.readAsText(file);
			} else {
				reader.readAsArrayBuffer(file);
			}
		} else {
			dispatch(webinarAttendanceImportSetFileName(null));
			dispatch(
				webinarAttendanceDataLoaded({
					fields: null,
					data: null,
				}),
			);
		}
	};
};

const changeWebinarAttendeeName = (index, attendeeName, attendeeSurname) => ({
	type: Types.COURSES_CHANGE_WEBINAR_ATTENDEE_NAME,
	index,
	attendeeName,
	attendeeSurname,
});

const changeWebinarAttendeeEmail = (index, attendeeEmail) => ({
	type: Types.COURSES_CHANGE_WEBINAR_ATTENDEE_EMAIL,
	index,
	attendeeEmail,
});

const setWebinarAttendeeCertificateStatus = (index, status) => ({
	type: Types.COURSES_SET_WEBINAR_ATTENDEE_CERTIFICATE_STATUS,
	index,
	status,
});

const addNewAttendee = () => ({
	type: Types.COURSES_ADD_NEW_ATTENDEE,
});

const setAllCertificatesStatus = (status) => ({
	type: Types.COURSES_SET_ALL_CERTIFICATES_STATUS,
	status,
});

const Actions = {
	handleWebinarAttendanceFiles,
	changeWebinarAttendeeName,
	changeWebinarAttendeeEmail,
	setWebinarAttendeeCertificateStatus,
	addNewAttendee,
	setAllCertificatesStatus,
};

export { Types, Actions };
